import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const noIndexTitles = ["3 Gratis Flaschen sichern", "Hier können Sie sleep.ink-Produkte kaufen"]

function SEO({ seo }) {
  const { fallback } = useStaticQuery(
    graphql`
      query {
        fallback: sanityPage(slug: { current: { eq: "home" } }) {
          ...PageSEO
        }
      }
    `
  )

  const data = seo || fallback.seo
  const title = data.title || fallback.seo.title
  const description = data.description || fallback.seo.description
  const ogImage = data.ogImage || fallback.seo.ogImage

  const socialImageFacebook = ogImage.asset.facebook.src
  const socialImageTwitter = ogImage.asset.twitter.src

  return (
    <Helmet htmlAttributes={{ lang: "de" }} title={title} titleTemplate={`%s | sleep.ink`}>
      <meta name="description" content={description} />
      {noIndexTitles.includes(title) && <meta name="robots" content="noindex" />}
      <meta name="og:title" content={title} />
      <meta name="og:description" content={description} />
      <meta name="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="theme-color" content="#000000" />
      <meta name="twitter:creator" content="@sleepink" />
      <meta name="og:image" content={socialImageFacebook} />
      <meta name="twitter:image" content={socialImageTwitter} />
      <meta name="p:domain_verify" content="47ff7cf35b0673df95e206f90a5a52b1" />
      {/* <meta name="google-site-verification" content="3iWgXmrZKcM7V1nVvvqPaJB8-qNo0vcO46qk_E46SQE" /> */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=yes"
      />
      <meta name="google-site-verification" content="4Lalf7BHqpy0ThHPSD_PUAqhmhvJQAqHDxpXbBhS4Hs" />
      <script>
        {`window.pushowl = window.pushowl || {
      queue: [],
      trigger: function(taskName, taskData) {
        return new Promise((resolve, reject) => {
          this.queue.push({
            taskName,
            taskData,
            promise: { resolve, reject },
          })
        })
      },
      init: function() {
        const subdomain = "sleep-ink"
        if (!subdomain) {
          return
        }
        this.subdomain = subdomain
        var s = document.createElement("script")
        s.type = "text/javascript"
        s.async = true
        s.src = "https://cdn.pushowl.com/sdks/pushowl-sdk.js?subdomain=" + subdomain + "&environment=production&shop=" + subdomain + ".myshopify.com"
        var x = document.getElementsByTagName("script")[0]
        x.parentNode.insertBefore(s, x)
      },
    }
    window.pushowl.init()
    `}
      </script>
      <script
        src="https://integrations.etrusted.com/applications/widget.js/v2"
        defer
        async
      ></script>
    </Helmet>
  )
}

export { SEO }
